import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    interval: { type: Number, default: 60000 } // 60 seconds default
  }

  connect() {
    this.startRefreshing()
  }

  disconnect() {
    this.stopRefreshing()
  }

  startRefreshing() {
    this.refreshTimer = setInterval(() => {
      this.refresh()
    }, this.intervalValue)
  }

  stopRefreshing() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  }

  refresh() {
    const frame = this.element.querySelector('turbo-frame') || this.element.closest('turbo-frame')
    if (frame && frame.src) {
      // Force reload by reassigning src (works across all Turbo versions)
      const src = frame.src
      frame.src = null
      frame.src = src
    }
  }
}
